import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../../util/reactIntl';
import { IconClose } from '../../../components';

import { getActiveFilterTags } from './activeFilterTagHelpers';

import css from './ActiveFilterTags.module.css';

/**
 * Removable active-filter tags shown above the filter sections.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.rootClassName]
 * @param {Object} props.urlQueryParams
 * @param {Object} props.config
 * @param {Array} props.listingFieldsConfig
 * @param {Array} props.defaultFiltersConfig
 * @param {Function} props.onRemove - Called with partial URL param updates
 * @returns {JSX.Element|null}
 */
const ActiveFilterTags = props => {
  const intl = useIntl();
  const {
    className,
    rootClassName,
    urlQueryParams,
    config,
    listingFieldsConfig,
    defaultFiltersConfig,
    onRemove,
  } = props;

  const tags = getActiveFilterTags({
    urlQueryParams,
    config,
    intl,
    listingFieldsConfig,
    defaultFiltersConfig,
  });

  if (tags.length === 0) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div
      className={classes}
      role="list"
      aria-label={intl.formatMessage({ id: 'ActiveFilterTags.ariaLabel' })}
    >
      {tags.map(tag => (
        <button
          key={tag.id}
          type="button"
          className={css.tag}
          role="listitem"
          onClick={() => onRemove(tag.removeParams)}
          aria-label={intl.formatMessage(
            { id: 'ActiveFilterTags.removeAriaLabel' },
            { label: tag.label }
          )}
        >
          <span className={css.tagLabel}>{tag.label}</span>
          <IconClose rootClassName={css.tagCloseIcon} size="small" />
        </button>
      ))}
    </div>
  );
};

export default ActiveFilterTags;
